import "./App.css";
import Product from "./components/Product";
import { Storage } from "aws-amplify";
import React, { useRef, useCallback, useEffect, useState } from "react";
import { API, Auth, graphqlOperation } from "aws-amplify";
import { withAuthenticator, AmplifySignOut } from "@aws-amplify/ui-react";
import DeleteForeverRoundedIcon from "@material-ui/icons/DeleteForeverRounded";
import CachedRoundedIcon from "@material-ui/icons/CachedRounded";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Typography } from "@material-ui/core";
import { onUpdateTranscriberConfig } from "./graphql/subscriptions";
import {
  createTranscriberConfig,
  updateTranscriberConfig,
} from "./graphql/mutations";
import {
  Button,
  Container,
  Alert,
  Card,
  Form,
  Col,
  Badge,
  Modal,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const useStyles = makeStyles((theme) => ({
  wholepage: {
    overflowX: "hidden",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  spacing: {
    flexGrow: 1,
  },
  header: {
    marginTop: "100px",
    textAlign: "left",
    color: "#3f51b5",
    fontSize: "45px",
  },
  headernarrowscreen: {
    marginTop: "100px",
    textAlign: "left",
    color: "#3f51b5",
    fontSize: "35px",
  },
  subheader: {
    fontSize: "25px",
    marginBottom: "20px",
    marginLeft: "140px",
  },
  subheadernarrowscreen: {
    fontSize: "25px",
    marginBottom: "20px",
    marginLeft: "20px",
  },
  bodyrow: {
    marginTop: "200px",
    display: "flex",
    flexDirection: "row",
  },
  narrowscreenusecolumn: {
    display: "flex",
    flexDirection: "column",
  },
  bodycolumn: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    alignItems: "left",
  },
  narrowscreenbodycolumn: {
    marginTop: "100px",
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
  },
  selectfileinstruction: {
    marginBottom: "30px",
  },
  inputactivator: {
    backgroundColor: "pink",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingLeft: "10px",
  },
  formnarrowscreen: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingLeft: "10px",
  },
  buttonrow: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  numbering: {
    marginRight: "30px",
  },
  confirmation: {
    marginLeft: "30px",
    marginRight: "30px",
  },
  downlaodfilename: {
    width: "100%",
  },
  downlaodfilenamepointer: {
    cursor: "pointer",
    textTransform: "none",
  },
  deletefile: {
    cursor: "pointer",
  },
}));

function App() {
  // const [userEmail, setUserEmail] = useState(null);
  const classes = useStyles();
  const product1 = {
    price: 4.49,
    name: "4.49 Credit",
    description: "41.58 Minutes",
  };

  const product2 = {
    price: 8.99,
    name: "8.99 Credit",
    description: "83.25 Minutes",
  };

  const product3 = {
    price: 17.99,
    name: "17.99 Credit",
    description: "166.58 Minutes",
  };

  const product4 = {
    price: 44.99,
    name: "44.99 Credit",
    description: "416.50 Minutes",
  };

  const product5 = {
    price: 89.99,
    name: "89.99 Credit",
    description: "833.25 Minutes",
  };

  const transcribeRate = 0.002;
  const humanTranscribeRate = 0.017;
  let rate = transcribeRate;
  // let transcriptionsArray = [];
  const [buyCredit, setBuyCredit] = useState(false);
  const [buyCreditSelection, setBuyCreditSelection] = useState(false);
  const [selectedCreditPackage, setSelectedCreditPackage] = useState(1);
  const [fileURL, setFileURL] = useState("");
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");
  const [creditId, setCreditId] = useState("");
  const [triggerList, setTriggerList] = useState(true);
  const [loggedInEmail, setLoggedInEmail] = useState("");
  const [transcriberConfigParam, updateTranscriberConfigParam] = useState(null);
  const [transcriberConfigValue, updateTranscriberConfigValue] = useState(null);
  const [buttonText, setButtonText] = useState(" No audio is selected ");
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [numberOfSpeakers, setNumberOfSpeakers] = useState("Auto");
  const [language, setLanguage] = useState(
    localStorage.getItem("language") === null
      ? "English US|en-US"
      : localStorage.getItem("language")
  );
  const [aiHuman, setAiHuman] = useState(
    localStorage.getItem("aiHuman") === null
      ? "AI"
      : localStorage.getItem("aiHuman")
  );

  //  console.log("oyoyoy:", localStorage.getItem("aiHuman"));
  //  console.log("oy", localStorage.getItem("aiHuman") === null);

  const [genericMedical, setGenericMedical] = useState("GENERIC");
  const [conversationDictation, setConversationDictation] = useState(
    "CONVERSATION"
  );
  const [audioDuration, setAudioDuration] = useState("-1");

  console.log(Auth.currentUserInfo());

  let product = product1;
  if (selectedCreditPackage == 2) {
    product = product2;
  } else if (selectedCreditPackage == 3) {
    product = product3;
  } else if (selectedCreditPackage == 4) {
    product = product4;
  } else if (selectedCreditPackage == 5) {
    product = product5;
  }

  function fetchUserAttr() {
    Auth.currentUserInfo().then((userInfo) => {
      const { attributes = {} } = userInfo;
      console.log("userEmail:", attributes["email"]);
      console.log("userAttributes:", userInfo.username);
      localStorage.setItem("loggedInEmail", attributes["email"]);
      setLoggedInEmail(attributes["email"]);
      localStorage.setItem("loggedInUser", userInfo.username);
    });
  }

  useEffect(() => {
    fetchUserAttr();
  }, []);

  //useEffect(() => {
  //  listTranscripts();
  //}, []);

  useEffect(() => {
    subscribe();
  }, []);

  useEffect(() => {
    submitEval();
  }, [audioDuration, rate, aiHuman]);

  useEffect(() => {
    getCurrentCredit();
  }, [loggedInEmail]);

  function subscribe() {
    API.graphql({
      query: onUpdateTranscriberConfig,
    }).subscribe({
      next: (messageData) => {
        updateTranscriberConfigParam(
          messageData.value.data.onUpdateTranscriberConfig.param
        );
        const userEmail = localStorage.getItem("loggedInEmail");
        if (
          userEmail === messageData.value.data.onUpdateTranscriberConfig.param
        ) {
          updateTranscriberConfigValue(
            messageData.value.data.onUpdateTranscriberConfig.value
          );
          submitEval();
          document.getElementById("formControlFile").value = null;
          fileSelectionHandler(null);
        }
      },
    });
  }

  function submitEval() {
    console.log("submitEval triggered");

    console.log("rate:", rate);
    console.log("credit:", transcriberConfigValue);
    console.log("audioDuration:", audioDuration);
    if (audioDuration <= 0) {
      setButtonText("No audio is selected");
      setButtonEnabled(false);
    } else if (audioDuration > transcriberConfigValue / rate) {
      setButtonText("Insufficient credit for the selected audio");
      setButtonEnabled(false);
    } else {
      setButtonText("Press to order transcription");
      setButtonEnabled(true);
    }

    console.log("buttonText:", buttonText);
    console.log("buttonEnabled:", buttonEnabled);
  }

  function updateUserCredit(val) {
    const updateCrditQuery =
      `mutation MyMutation {
    updateTranscriberConfig(input: {id: "` +
      creditId +
      `", value: "` +
      val +
      `"}) {
      param
      id
      createdAt
      updatedAt
      value
    }
  }`;
    const updateCredit = API.graphql(graphqlOperation(updateCrditQuery)).then(
      function (allEvents) {
        console.log(allEvents.data.updateTranscriberConfig);
      }
    );
    submitEval();
  }

  function insertZeroCredit() {
    const userEmail = localStorage.getItem("loggedInEmail");
    const insertZeroCreditQuery =
      `mutation MyMutation {
      createTranscriberConfig(input: {param: "` +
      userEmail +
      `", value: "0"}) {
        createdAt
        id
        param
        updatedAt
        value
      }
    }`;

    const userCreditData = API.graphql(
      graphqlOperation(insertZeroCreditQuery)
    ).then(function (allEvents) {
      console.log(allEvents);
      if (allEvents.data.createTranscriberConfigs.items.length == 0) {
      } else {
        console.log(allEvents.data.createTranscriberConfigs.items[0].id);
        updateTranscriberConfigValue(
          allEvents.data.createTranscriberConfigs.items[0].value
        );
        setCreditId(allEvents.data.createTranscriberConfigs.items[0].id);
      }
    });
  }
  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 1500);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  const deleteFile = (filename) => {
    // deletes a file
    Storage.remove(filename, {
      customPrefix: {
        public: "",
        protected: "",
        private: "",
      },
      bucket: "va-transcribed-results-bucket",
    })
      .then((result) => {
        console.log(result);
        refreshList();
      })
      .catch((err) => console.log(err));
  };

  function refreshList() {
    setTriggerList(!triggerList);
  }

  function getCurrentCredit() {
    const userEmail = localStorage.getItem("loggedInEmail");
    const userCredit =
      `query MyQuery {
    listTranscriberConfigs(limit: 10000, filter: {param: {contains: "` +
      userEmail +
      `"}}) {nextToken
      items {
        id
        param
        updatedAt
        value
        createdAt
      }
    }
  }`;

    console.log(userCredit);
    const userCreditData = API.graphql(graphqlOperation(userCredit)).then(
      function (allEvents) {
        console.log(allEvents);
        console.log(allEvents.data.listTranscriberConfigs.items.length);
        if (allEvents.data.listTranscriberConfigs.items.length == 0) {
          insertZeroCredit();
        } else {
          console.log(allEvents.data.listTranscriberConfigs.items[0].id);
          updateTranscriberConfigValue(
            allEvents.data.listTranscriberConfigs.items[0].value
          );
          setCreditId(allEvents.data.listTranscriberConfigs.items[0].id);
        }
      }
    );
  }

  const genericMedicalSelectionHandler = (selectedOption) => {
    setGenericMedical(selectedOption);
  };

  function generateUID() {
    // I generate the UID from two parts here
    // to ensure the random number provide enough bits.
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
  }

  const uploadFile = (e) => {
    e.preventDefault();
    console.log("Attempting to upload");
    setAlertMessage(
      "Upload is initiated for: " +
        fileName +
        ". We will notify you when the upload is complete. <u><b>Please do not close the browser</b></u>."
    );
    setShowAlert(true);
    fileSelectionHandler("");

    console.log(file.name); // didn't work

    var fileNameWithParam =
      localStorage.getItem("loggedInUser") +
      "/" +
      language.slice(-5) +
      "_-" +
      localStorage.getItem("loggedInEmail") +
      "_-" +
      generateUID() +
      "_-" +
      fileName.slice(0, -4) +
      "_-" +
      genericMedical.toLowerCase() +
      "_-no_-" +
      numberOfSpeakers +
      "_-PRIMARYCARE_-" +
      conversationDictation.toUpperCase() +
      "_-" +
      aiHuman.toUpperCase() +
      fileName.slice(-4);

    if (genericMedical.toLowerCase() === "generic") {
      fileNameWithParam =
        localStorage.getItem("loggedInUser") +
        "/" +
        language.slice(-5) +
        "_-" +
        localStorage.getItem("loggedInEmail") +
        "_-" +
        generateUID() +
        "_-" +
        fileName.slice(0, -4) +
        "_-" +
        genericMedical.toLowerCase() +
        "_-no_-" +
        numberOfSpeakers +
        "_-" +
        aiHuman.toUpperCase() +
        fileName.slice(-4);
    }

    //    Storage.put(new_file.name, new_file)
    Storage.put(fileNameWithParam, file)
      .then(() => {
        setAlertMessage(
          fileName.toString() +
            " has been uploaded successfully. The transcription will be emailed to you upon completion. Thank you for your business!"
        );
        updateUserCredit(transcriberConfigValue - audioDuration * rate);

        setShowAlert(true);

        setFileName("");
        setFile("");
        setFileURL("");
      })
      .catch((err) => {
        console.log("error uploading file");
        setAlertMessage(
          "We have encountered an error uploading " +
            fileName +
            ". Please try again."
        );
        setShowAlert(true);
      });
  };

  const fileSelectionHandler = (target) => {
    try {
      let file = target.files[0];
      setFile(file);
      setFileURL(URL.createObjectURL(file));
      setFileName(file.name);

      console.log(file);
      let reader = new FileReader();
      reader.onload = function (event) {
        var audioContext = new (window.AudioContext ||
          window.webkitAudioContext)();
        audioContext.decodeAudioData(event.target.result, function (buffer) {
          var duration = buffer.duration;
          console.log("The duration of file: " + duration + " seconds");
          setAudioDuration(duration);
        });
      };
      reader.onerror = function (event) {
        console.error("An error ocurred reading the file: ", event);
      };

      reader.readAsArrayBuffer(file);
    } catch (err) {
      setAudioDuration(0);
    }
  };

  const aiHumanSelectionHandler = (target) => {
    console.log("human ai selection: ", target.value);
    localStorage.setItem("aiHuman", target.value);
    setAiHuman(target.value);
    if (target.value === "HUMAN") {
      setAlertMessage(
        "Human transcription service is $1/min. The work will be delivered to your email within 24 hours. The accuracy is over 99%. 100% guaranteed."
      );
    } else {
      setAlertMessage(
        "SmartScribe's A.I. is fast, economical, and with a higher accuracy than an average transcription algorithms in the industry. The result will be sent to your email. Delivery speed depends on the lenght of the audio; for a 30 minutes audio, the transcription is typically delivered in less than 10 minutes."
      );
    }
    setShowAlert(true);
  };

  const languageSelectionHandler = (target) => {
    localStorage.setItem("language", target.value);
    setLanguage(target.value);
  };

  const conversationDictationSelectionHandler = (target) => {
    localStorage.setItem("conversationDictation", target.value);
    setConversationDictation(target.value);
  };

  const numberOfSpeakersSelectionHandler = (target) => {
    setNumberOfSpeakers(target.value);
  };

  let conversationDictationDiv = null;
  let audioEvalDiv = null;

  if (genericMedical === "MEDICAL") {
    conversationDictationDiv = (
      <div>
        <Card className="mb-3" border="primary">
          <Card.Body>
            <Form.Group>
              <Form.Label>
                <Badge pill variant="primary">
                  6
                </Badge>{" "}
                Conversation / Dictation:
              </Form.Label>
              <Form.Control
                as="select"
                size="sm"
                value={conversationDictation}
                onChange={(event) => {
                  conversationDictationSelectionHandler(event.currentTarget);
                }}
              >
                <option>CONVERSATION</option>
                <option>DICTATION</option>
              </Form.Control>
            </Form.Group>
          </Card.Body>
        </Card>
      </div>
    );
  }

  let genericMedicalDiv = null;
  if (language === "English US|en-US") {
    genericMedicalDiv = (
      <Card className="mb-3" border="primary">
        <Card.Body>
          <Form.Group>
            <Form.Label>
              <Badge pill variant="primary">
                5
              </Badge>{" "}
              Generic / Medical:
            </Form.Label>
            <Form.Control
              as="select"
              size="sm"
              custom
              onChange={(event) => {
                genericMedicalSelectionHandler(event.currentTarget.value);
              }}
              value={genericMedical}
            >
              <option>GENERIC</option>
              <option>MEDICAL</option>
            </Form.Control>
          </Form.Group>
        </Card.Body>
      </Card>
    );
  }
  if (genericMedical === "MEDICAL" && language !== "English US|en-US") {
    setGenericMedical("GENERIC");
  }
  if (aiHuman === "AI") {
    rate = transcribeRate;
  } else {
    rate = humanTranscribeRate;
  }

  if (audioDuration > 0) {
    audioEvalDiv = (
      <div>
        <span size="sm">
          <Badge pill variant="primary">
            1
          </Badge>{" "}
          Audio selected with duration:{" "}
          {Math.round((audioDuration * 100) / 60) / 100} mins
        </span>
      </div>
    );
  } else {
    audioEvalDiv = (
      <div>
        <span size="sm">
          {" "}
          <Badge pill variant="primary">
            1
          </Badge>{" "}
          Choose an audio file for transcription.
        </span>
      </div>
    );
  }

  const creditPackageSelectionHandler = (val) => {
    setSelectedCreditPackage(val);
    setBuyCredit(true);
  };

  let creditPackages = (
    <div>
      <Button
        variant="outline-primary"
        onClick={() => {
          creditPackageSelectionHandler(1);
        }}
      >
        $4.49 (41.58 Mins)
      </Button>{" "}
      <Button
        variant="outline-primary"
        onClick={() => {
          creditPackageSelectionHandler(2);
        }}
      >
        {" "}
        $8.99 (83.25 Mins){" "}
      </Button>{" "}
      <Button
        variant="outline-primary"
        onClick={() => {
          creditPackageSelectionHandler(3);
        }}
      >
        {" "}
        $17.99 (166.58 Mins){" "}
      </Button>{" "}
      <Button
        variant="outline-primary"
        onClick={() => {
          creditPackageSelectionHandler(4);
        }}
      >
        {" "}
        $44.99 (416.50 Mins){" "}
      </Button>{" "}
      <Button
        variant="outline-primary"
        onClick={() => {
          creditPackageSelectionHandler(5);
        }}
      >
        {" "}
        $89.99 (833.25 Mins){" "}
      </Button>{" "}
      <Button
        onClick={() => {
          setBuyCreditSelection(false);
        }}
      >
        {" "}
        CLOSE
      </Button>
    </div>
  );

  // const listTranscripts = () => {
  //   Storage.list(localStorage.getItem("loggedInUser") + "/", {
  //     customPrefix: {
  //       public: "",
  //       protected: "",
  //       private: "",
  //     },
  //     bucket: "va-transcribed-results-bucket",
  //   }).then((result) => {
  //     console.log(result);
  //     result.forEach((element) => {
  //       if (element.key.slice(-4) === "docx") {
  //         transcriptionsArray.push(element.key);
  //         console.log(element.key);
  //       }
  //     });
  //   });
  // };

  const [boardList, setBoardList] = useState();

  useEffect(() => {
    // gets all of the file names
    Storage.list(localStorage.getItem("loggedInUser") + "/", {
      customPrefix: {
        public: "",
        protected: "",
        private: "",
      },
      bucket: "va-transcribed-results-bucket",
    }).then((result) => {
      let docxFiles = [];
      result.forEach((element) => {
        console.log(element);
        if (element.key.slice(-4) === "docx") {
          element.friendlyName =
            element.key.split("-generic-") == null
              ? element.key.split("-medical-")[0].split("-")[4] == ""
                ? "[UNTITLED]"
                : element.key
                    .split("-medical-")[0]
                    .split("-")
                    .slice(
                      4,
                      element.key.split("-medical-")[0].split("-").length
                    )
                    .join("-")
              : element.key.split("-generic-")[0].split("-")[4] == ""
              ? "[UNTITLED]"
              : element.key
                  .split("-medical-")[0]
                  .split("-")
                  .slice(4, element.key.split("-generic-")[0].split("-").length)
                  .join("-") + ".docx";
          docxFiles.push(element);
        }
      });
      docxFiles.sort((a, b) => (a.lastModified > b.lastModified ? -1 : 1));
      setBoardList(docxFiles);
    });
  }, [triggerList]);

  const handleDownload = async (filename, friendlyName) => {
    await Storage.get(filename, {
      customPrefix: {
        public: "",
        protected: "",
        private: "",
      },
      bucket: "va-transcribed-results-bucket",
      download: true,
    }).then((res) => downloadBlob(res.Body, friendlyName));
  };

  const getBoardList = useCallback(() => {
    return boardList;
  }, [boardList]);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <div className="App">
      <AmplifySignOut button-text="Custom Text"></AmplifySignOut>

      {buyCreditSelection ? creditPackages : null}

      <Modal
        show={buyCredit}
        onHide={() => {
          setBuyCredit(false);
        }}
      >
        <Modal.Header>
          <Modal.Title>Purchase SmartScribe Credits</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Product
            product={product}
            updatecredit={updateUserCredit}
            currentcredit={transcriberConfigValue}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setBuyCredit(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <header>
        <Container>
          <h1>
            <span Style="color:#59a6ff">
              <b>S</b>
            </span>
            <span Style="color:#5b5c5c">mart</span>
            <span Style="color:#59a6ff">
              <b>S</b>
            </span>
            <span Style="color:#5b5c5c">cribe</span>
          </h1>
          <Form onSubmit={uploadFile}>
            <div className="test">
              <Form.Row>
                <Col>
                  <Alert variant="primary">
                    Available Minutes:{" "}
                    {Math.round((transcriberConfigValue * 100) / (rate * 60)) /
                      100}
                  </Alert>
                </Col>

                <Col>
                  <Alert variant="primary">
                    <Alert.Link
                      onClick={() => {
                        setBuyCreditSelection(true);
                      }}
                    >
                      Purchase Credits
                    </Alert.Link>
                  </Alert>
                </Col>
              </Form.Row>

              <Alert show={showAlert} variant="primary" size="sm">
                <div dangerouslySetInnerHTML={{ __html: alertMessage }} />
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => setShowAlert(false)}
                    variant="outline-primary"
                  >
                    Ok! I understand.
                  </Button>
                </div>
              </Alert>

              <Form.Row>
                <Col>
                  <Card className="mb-3" border="primary">
                    {" "}
                    <Card.Body>
                      <Form.Group>
                        <Card.Title>
                          <Form.File
                            variant="outline-info"
                            id="formControlFile"
                            onChange={(event) => {
                              fileSelectionHandler(event.currentTarget);
                            }}
                          />
                        </Card.Title>
                      </Form.Group>
                      <Card.Text>{audioEvalDiv}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                <Col>
                  <Card className="mb-3" border="primary">
                    <Card.Body>
                      <Form.Group>
                        <Form.Label>
                          <Badge pill variant="primary">
                            2
                          </Badge>{" "}
                          Spoken Language/Dialect:
                        </Form.Label>
                        <Form.Control
                          as="select"
                          size="sm"
                          value={language}
                          onChange={(event) => {
                            languageSelectionHandler(event.currentTarget);
                          }}
                        >
                          <option>English US|en-US</option>
                          <option>Swiss German|de-CH</option>
                          <option>Arabic Gulf|ar-AE</option>
                          <option>Chinese Mandarin|zh-CN</option>
                          <option>German|de-DE</option>
                          <option>Arabic|ar-SA</option>
                          <option>English Scottish|en-AB</option>
                          <option>Russian|ru-RU</option>
                          <option>French Canadian|fr-CA</option>
                          <option>French|fr-FR</option>
                          <option>Portuguese|pt-PT</option>
                          <option>Dutch|nl-NL</option>
                          <option>Tamil|ta-IN</option>
                          <option>Turkish|tr-TR</option>
                          <option>Telugu|te-IN</option>
                          <option>Japanese|ja-JP</option>
                          <option>Spanish US|es-US</option>
                          <option>English Indian|en-IN</option>
                          <option>Portuguese Br|pt-BR</option>
                          <option>Korean|ko-KR</option>
                          <option>Hebrew|he-IL</option>
                          <option>Indonesian|id-ID</option>
                          <option>English Australian|en-AU</option>
                          <option>English Irish|en-IE</option>
                          <option>Spanish|es-ES</option>
                          <option>Indian Hindi|hi-IN</option>
                          <option>Italian|it-IT</option>
                          <option>English British|en-GB</option>
                          <option>Malay|ms-MY</option>
                          <option>English Welsh|en-WL</option>
                          <option>Farsi|fa-IR</option>
                        </Form.Control>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Col>
              </Form.Row>

              <Form.Row>
                <Col>
                  <Card className="mb-3" border="primary">
                    <Card.Body>
                      <Form.Group>
                        <Form.Label size="sm">
                          <Badge pill variant="primary">
                            3
                          </Badge>{" "}
                          Number of speakers in the audio:
                        </Form.Label>
                        <Form.Control
                          as="select"
                          size="sm"
                          value={numberOfSpeakers}
                          onChange={(event) => {
                            numberOfSpeakersSelectionHandler(
                              event.currentTarget
                            );
                          }}
                        >
                          <option>Auto</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </Form.Control>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card className="mb-3" border="primary">
                    <Card.Body>
                      <Form.Group>
                        <Form.Label>
                          <Badge pill variant="primary">
                            4
                          </Badge>{" "}
                          A.I. / Human:
                        </Form.Label>
                        <Form.Control
                          as="select"
                          size="sm"
                          onChange={(event) => {
                            aiHumanSelectionHandler(event.currentTarget);
                          }}
                          value={aiHuman}
                        >
                          <option>AI</option>
                          <option>HUMAN</option>
                        </Form.Control>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Col>
              </Form.Row>

              <Form.Row>
                <Col>{genericMedicalDiv}</Col>
                <Col>{conversationDictationDiv}</Col>
              </Form.Row>
              <Form.Row>
                <Col>
                  <Button
                    className="mb-3"
                    type="submit"
                    variant="primary"
                    disabled={!buttonEnabled}
                  >
                    {buttonText}
                  </Button>
                </Col>
              </Form.Row>
            </div>
          </Form>
          <p>
            <Alert variant="primary">
              Have questions or feedback?
              <Alert.Link href="mailto:smartscribe.support@ultratechstudio.com">
                {" "}
                Reach out to us!{" "}
              </Alert.Link>
            </Alert>
          </p>
          <h1>
            <span Style="color:#59a6ff">
              <b>T</b>
            </span>
            <span Style="color:#5b5c5c">ranscribed</span>
            <span Style="color:#59a6ff">
              <b>R</b>
            </span>
            <span Style="color:#5b5c5c">esults</span>
            &nbsp;
            <Button variant="outline-primary" size="sm">
              <CachedRoundedIcon
                fontSize="large"
                variant="button"
                onClick={() => {
                  refreshList();
                }}
              />
            </Button>
          </h1>

          <div className="test">
            <div className={matches ? classes.form : classes.formnarrowscreen}>
              {getBoardList() &&
                getBoardList().map((record) => (
                  <div className={classes.buttonrow} key={record.key}>
                    <div className={classes.downlaodfilename}>
                      <Typography
                        variant="button"
                        onClick={() => {
                          handleDownload(record.key, record.friendlyName);
                        }}
                        aria-hidden="true"
                        className={classes.downlaodfilenamepointer}
                      >
                        {record.friendlyName}
                      </Typography>
                    </div>
                    <div>
                      <Button variant="outline-primary" size="sm">
                        <DeleteForeverRoundedIcon
                          variant="button"
                          onClick={() => {
                            deleteFile(record.key);
                          }}
                        />
                      </Button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Container>
      </header>
    </div>
  );
}

export default withAuthenticator(App, true);
